import { ONDUTY_ID, SEXES_LIST, UF_LIST } from '@/constants'
import { Registry } from '@/entities/Registry'

import {
  Input,
  Dropdown,
  DatePicker,
  Checkbox,
  Grid,
  Center,
  Button,
  MultiSelect,
  InputPassword,
} from '@conexasaude/hero-web'
import { useForm, yupResolver } from '@mantine/form'

import { FunctionComponent, useEffect, useState } from 'react'
import { getSchema } from './schema'
import { InformationFormProps } from './types'
import ReCAPTCHA from 'react-google-recaptcha'

const RegisterForm: FunctionComponent<InformationFormProps> = ({
  recaptchaRef,
  specialities,
  loading,
  preferences,
  availabityCalls,
  onSubmit,
  clinicId,
}) => {
  const [registry] = useState(Registry.createRegistry())
  const [isOnDuty, setIsOnDuty] = useState(false)

  const form = useForm({
    schema: yupResolver(getSchema(!!clinicId)),
    initialValues: registry,
  })

  useEffect(() => {
    if (parseInt(form.values.preferenceForAttendance) === ONDUTY_ID) {
      form.values.speciality = null
      form.values.anotherSpeciality = ''
      setIsOnDuty(true)
    } else {
      setIsOnDuty(false)
    }
    // eslint-disable-next-line
  }, [form.values.preferenceForAttendance])

  return (
    <form onSubmit={form.onSubmit(values => onSubmit(values, form))}>
      <Grid align="center">
        <Grid.Col sm={6}>
          <Input
            label="Seu nome"
            placeholder="Nome"
            fullWidth
            {...form.getInputProps('name')}
          />
        </Grid.Col>
        <Grid.Col sm={6}>
          <Input
            label="Seu sobrenome"
            placeholder="sobrenome"
            fullWidth
            {...form.getInputProps('lastName')}
          />
        </Grid.Col>

        <Grid.Col sm={6}>
          <Input
            label="E-mail"
            type="email"
            fullWidth
            {...form.getInputProps('email')}
          />
        </Grid.Col>
        <Grid.Col sm={6}>
          <DatePicker
            label="Data de nascimento"
            fullWidth
            allowFreeInput
            fixOnBlur={false}
            clearable
            dateParser={dateString => {
              const cleanedDateString = dateString.replace(/ˆ[0-9]/g, '')
              const day = cleanedDateString.substring(0, 2)
              const month = cleanedDateString.substring(2, 4)
              const year = cleanedDateString.substring(4, 8)

              return new Date(`${year}/${month}/${day}`)
            }}
            {...form.getInputProps('birthday')}
          />
        </Grid.Col>

        <Grid.Col sm={6}>
          <Input
            label="Cidade do nascimento"
            fullWidth
            {...form.getInputProps('hometown')}
          />
        </Grid.Col>
        <Grid.Col sm={6}>
          <Input
            label="Celular"
            mask="(00) 00000-0000"
            fullWidth
            {...form.getInputProps('celular')}
          />
        </Grid.Col>
        <Grid.Col sm={6}>
          <Input
            label="CPF"
            mask="000.000.000-00"
            fullWidth
            {...form.getInputProps('cpf')}
          />
        </Grid.Col>
        <Grid.Col sm={6}>
          <InputPassword
            label="Crie sua Senha"
            fullWidth
            {...form.getInputProps('password')}
          />
        </Grid.Col>
        <Grid.Col sm={6}>
          <Dropdown
            data={SEXES_LIST}
            label="Seu sexo"
            fullWidth
            {...form.getInputProps('sex')}
          />
        </Grid.Col>

        <Grid.Col sm={6}>
          <Input
            label="Digite seu CRM"
            mask="000000"
            fullWidth
            {...form.getInputProps('crm')}
          />
        </Grid.Col>
        <Grid.Col sm={6}>
          <Dropdown
            data={UF_LIST}
            label="UF do CRM"
            fullWidth
            {...form.getInputProps('ufCrm')}
          />
        </Grid.Col>

        {!clinicId && (
          <Grid.Col sm={6}>
            <Dropdown
              data={preferences}
              label="Como pretende atender?"
              fullWidth
              {...form.getInputProps('preferenceForAttendance')}
            />
          </Grid.Col>
        )}

        <Grid.Col sm={6}>
          <Dropdown
            data={specialities}
            label="Sua especialidade"
            fullWidth
            {...form.getInputProps('speciality')}
            disabled={isOnDuty}
          />
        </Grid.Col>
        <Grid.Col sm={6}>
          <Input
            label="Outra Especialidade"
            fullWidth
            disabled={isOnDuty}
            {...form.getInputProps('anotherSpeciality')}
          />
        </Grid.Col>
        <Grid.Col sm={6}>
          <MultiSelect
            label="Horários disponíveis"
            fullWidth
            data={availabityCalls}
            {...form.getInputProps('serviceAvailability')}
          />
        </Grid.Col>

        <Grid.Col sm={6}>
          <Checkbox
            label="Possui o certificado digital?"
            {...form.getInputProps('hasBirdId')}
            checked={form.getInputProps('hasBirdId').value}
          />
          <Checkbox
            label="Possui CNPJ?"
            {...form.getInputProps('hasCnpj')}
            checked={form.getInputProps('hasCnpj').value}
          />
        </Grid.Col>

        <Grid.Col>
          <Center>
            <Button busy={loading} type="submit">
              Enviar cadastro
            </Button>
          </Center>
        </Grid.Col>
        <Grid.Col>
          <ReCAPTCHA
            ref={recaptchaRef}
            size="invisible"
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
          />
        </Grid.Col>
      </Grid>
    </form>
  )
}

export default RegisterForm
